import React, { useEffect, useRef, useState } from "react";
import "../Styles/SkinGroomingSection.css";

const SkinGroomingSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIsVisible(entry.isIntersecting),
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const services = [
   
    {
      title: "GROOMING",
      items: ["Manicure", "Pedicure", "Threading", "Waxing"],
    },
    {
      title: "SPECIALS",
      items: ["Bridal Skin Care", "Groom Skin Care", "Luxury Spa Treatments"],
    },
  ];

  // WhatsApp booking handler
  const handleBookAppointment = () => {
    const phone = "919912232487"; // include country code (91 for India)
    const message =
      "Hello, I would like to book an appointment for Skin & Grooming services.";
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <section
      ref={sectionRef}
      className={`skin-section ${isVisible ? "fade-in" : ""}`}
    >
      {/* Section Title */}
      <h2 className={`section-title ${isVisible ? "show" : ""}`}>
        Skin & Grooming
      </h2>

      {/* Service Categories Grid */}
      <div className="skin-grooming-grid">
        {services.map((srv, idx) => (
          <div key={srv.title} className="grooming-block">
            <h3
              className={`skin-title ${isVisible ? "show" : ""}`}
              style={{ transitionDelay: `${0.2 + idx * 0.2}s` }}
            >
              {srv.title}
            </h3>
            <ul className="skin-list">
              {srv.items.map((it, i) => (
                <li
                  key={i}
                  className={`skin-item ${isVisible ? "show" : ""}`}
                  style={{
                    transitionDelay: `${0.4 + (idx * 3 + i) * 0.1}s`,
                  }}
                >
                  {it}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {/* Book Appointment Button */}
      <div className="book-btn-container">
        <button className="book-btn" onClick={handleBookAppointment}>
          📅 BOOK APPOINTMENT
        </button>
      </div>
    </section>
  );
};

export default SkinGroomingSection;
